<template>
  <div class="product-box" :class="{ 'in-cart': isInCart }">
    <div class="product-image-container">
      <a href="#" @click.prevent="onProductClick(product)" class="product-link">
        <img :alt="product.code_based" :src="getImage" class="product-image">
        <div v-if="actualStock <= 0" class="out-of-stock-badge">AGOTADO</div>
        <div v-if="hasPromoDiscount" class="promo-badge">
          <span class="promo-text">¡OFERTA!</span>
          <span class="promo-percentage">-{{product.discount_percentage}}%</span>
        </div>
      </a>
    </div>

    <div class="product-details">
      <div class="product-header">
        <h2 class="product-title" v-html="product.code_based"></h2>
        <span class="product-code" v-html="product.pricelist_id"></span>
      </div>

      <p class="product-description" v-html="product.description"></p>

      <div class="product-pricing">
        <template v-if="product.pack !== '1'">
          <div v-if="actualStock > 0" class="price-container">
            <span class="price-label">Precio Individual:</span>
            <div class="price-display">
              <span v-if="hasDiscount" class="price-original">{{product.price | currency }} + IVA</span>
              <span class="price-value" :class="{'price-discounted': hasDiscount}">{{finalPrice | currency }} + IVA</span>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-if="actualStock > 0" class="price-container">
            <div class="price-row">
              <span class="price-label">Precio Individual:</span>
              <div class="price-display">
                <span v-if="hasDiscount" class="price-original">{{product.price | currency }} + IVA</span>
                <span class="price-value" :class="{'price-discounted': hasDiscount}">{{finalPrice | currency }} + IVA</span>
              </div>
            </div>
            <div class="price-row unit-price">
              <span class="price-label">Precio Unitario:</span>
              <div class="price-display">
                <span v-if="hasDiscount" class="price-original">{{product.price / product.pack | currency }} + IVA</span>
                <span class="price-value" :class="{'price-discounted': hasDiscount}">{{finalPrice / product.pack | currency }} + IVA</span>
              </div>
            </div>
          </div>
        </template>
      </div>

      <div v-if="actualStock > 0" class="product-actions">
        <div class="quantity-selector">
          <div class="quantity-input-group">
            <button
              class="quantity-btn"
              @click="decreaseQuantity"
              :disabled="!canDecrease"
            >
              <i class="fa fa-minus"></i>
            </button>
            <input
              type="number"
              class="quantity-input"
              v-model.number="quantity"
              @change="onQuantityInput"
              :min="rangeStock[0]"
              :max="rangeStock[rangeStock.length-1]"
              step="1"
            >
            <button
              class="quantity-btn"
              @click="increaseQuantity"
              :disabled="!canIncrease"
            >
              <i class="fa fa-plus"></i>
            </button>
          </div>
          <div class="stock-info" v-if="product.STOCK > 0">
            <i class="fa fa-cubes"></i>
            Stock disponible: {{product.stock_available}} unidades
          </div>

          <div class="stock-info mt-4" style="margin-top: 5px;" v-if="product.barcode !== ''">
            <i class="fa fa-barcode"></i>
            EAN: <span style="font-weight: bold">{{product.barcode}}</span>
          </div>
        </div>
        <button class="add-to-cart-btn" @click="quickAddToCart(product)">
          <span class="btn-text">AGREGAR AL CARRITO</span>
        </button>
        <button v-if="isInCart" class="remove-from-cart-btn" @click="removeFromCart(product)">
          <span class="btn-text">QUITAR DEL CARRITO</span>
        </button>
      </div>

      <div class="purchase-limits" v-if="product.product_purchase_min > 1 || product.product_purchase_max > 1">
        <p v-if="product.product_purchase_min > 1" class="limit-info">
          <i class="fa fa-info-circle"></i>
          Mínimo de compra: {{product.product_purchase_min}} unidades
        </p>
        <p v-if="product.product_purchase_max > 1 && product.product_purchase_max < product.stock_available" class="limit-info">
          <i class="fa fa-info-circle"></i>
          Máximo de compra: {{product.product_purchase_max}} unidades
        </p>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        props:['product','onProductClick'],
        data(){
          return {
            quantity: 1
          };
        },
        computed:{
          getImage(){
            if (!this.product.images.length)
            {
              return '/static/img/noimage.jpg';
            }

            return this.product.images[0].url;
          },
          isInCart() {
            return this.$store.state.cart.items.some(item => item.product.code === this.product.code);
          },
          hasDiscount() {
            return this.product.enable_discount && this.product.discount_percentage > 0;
          },
          hasPromoDiscount() {
            return this.hasDiscount && this.product.discount_percentage >= 50;
          },
          finalPrice() {
            if (this.hasDiscount) {
              return this.product.price * (1 - this.product.discount_percentage / 100);
            }
            return this.product.price;
          },
          rangeStock(){
            let maxToShow = parseInt(this.product.stock_available);
            let multiplier = parseInt((this.product.product_multiplier) ? this.product.product_multiplier : 1);
            let minToShow = parseInt(this.product.product_purchase_min || 1);

            if (this.product.product_purchase_max > 1) {
              maxToShow = Math.min(maxToShow, parseInt(this.product.product_purchase_max));
            }

            var ans = [];
            for (let i = minToShow; i <= maxToShow; i++) {
              if (i % multiplier === 0) {
                ans.push(i);
              }
            }
            return ans;
          },
          actualStock(){
            return parseInt(this.product.stock_available);
          },
          canDecrease() {
            const allowed = this.rangeStock;
            return allowed.indexOf(this.quantity) > 0;
          },
          canIncrease() {
            const allowed = this.rangeStock;
            return allowed.indexOf(this.quantity) < allowed.length - 1;
          }
        },
        methods: {
          decreaseQuantity() {
            const allowed = this.rangeStock;
            const idx = allowed.indexOf(this.quantity);
            if (idx > 0) {
              this.quantity = allowed[idx - 1];
            }
          },
          increaseQuantity() {
            const allowed = this.rangeStock;
            const idx = allowed.indexOf(this.quantity);
            if (idx < allowed.length - 1) {
              this.quantity = allowed[idx + 1];
            }
          },
          onQuantityInput() {
            const allowed = this.rangeStock;
            let val = Number(this.quantity);
            // Snap to closest allowed value
            let closest = allowed.reduce((prev, curr) =>
              Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev
            );
            this.quantity = closest;
          },
          quickAddToCart(product){
            if (this.quantity < this.product.product_purchase_min) {
              this.$swal({
                title: 'Oops!',
                text: 'La cantidad minima de compra es de '+this.product.product_purchase_min+' unidades',
                type: 'error',
              });
              return;
            }

            this.$store.dispatch('addToCart', {product:product, quantity:this.quantity})
              .then(() => {
                this.$swal({
                  title: 'Producto agregado',
                  text: product.code_based + " agregado",
                  timer: 1200,
                  showCancelButton: false,
                  showConfirmButton: false,
                  type: 'success',
                });
              })
              .catch(err => {
                this.$swal({
                  title: 'Oops!',
                  text: err,
                  type: 'error',
                });
              });
          },
          removeFromCart(product) {
            this.$store.dispatch('RemoveCodArticuFromCart', this.product.code)
              .then(() => {
                this.$swal({
                  title: 'Producto quitado',
                  text: this.product.code_based + " quitado del carrito",
                  timer: 1200,
                  showCancelButton: false,
                  showConfirmButton: false,
                  type: 'success',
                });
              })
              .catch(err => {
                this.$swal({
                  title: 'Oops!',
                  text: err,
                  type: 'error',
                });
              });
          }
        },
        mounted() {
          if (this.product.product_purchase_min > 1) {
            this.quantity = this.product.product_purchase_min;
          }
        }
    }
</script>

<style scoped>
.product-box {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  overflow: hidden;
  margin-bottom: 20px;
  border: 2px solid transparent;
}

.product-box.in-cart {
  border-color: #DB5378;
}

.product-box:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.product-image-container {
  position: relative;
  padding-top: 75%;
  overflow: hidden;

}

.product-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
  padding: 10px;
}

.product-link:hover .product-image {
  transform: scale(1.05);
}

.out-of-stock-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: #DB5378;
  color: white;
  padding: 4px 12px;
  border-radius: 4px;
  font-size: 0.8em;
  font-weight: bold;
}

.promo-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-weight: bold;
  box-shadow: 0 4px 8px rgba(238, 90, 111, 0.4);
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.2;
  animation: pulse 2s ease-in-out infinite;
}

.promo-text {
  font-size: 0.7em;
  letter-spacing: 1px;
}

.promo-percentage {
  font-size: 1.1em;
  font-weight: 900;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.product-details {
  padding: 16px;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
}

.product-title {
  font-size: 1.1em;
  font-weight: 600;
  margin: 0;
  color: #333;
  flex: 1;
}

.product-code {
  font-size: 0.8em;
  color: #666;
  background: #f5f5f5;
  padding: 2px 6px;
  border-radius: 4px;
}

.product-description {
  font-size: 0.85em;
  color: #666;
  margin: 8px 0;
  line-height: 1.4;
}

.product-pricing {
  margin: 12px 0;
}

.price-container {
  background: #f8f9fa;
  padding: 8px 12px;
  border-radius: 6px;
}

.price-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px 0;
}

.unit-price {
  font-size: 0.9em;
  color: #666;
}

.price-label {
  font-size: 0.9em;
  color: #666;
}

.price-value {
  font-weight: 600;
  color: #2c3e50;
}

.price-display {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-end;
}

.price-original {
  font-size: 0.85em;
  color: #999;
  text-decoration: line-through;
  font-weight: 400;
}

.price-value.price-discounted {
  color: #e74c3c;
  font-weight: 700;
  font-size: 1.1em;
}

.product-actions {
  margin-top: 16px;
}

.quantity-selector {
  margin-bottom: 12px;
}

.quantity-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f8f9fa;
  padding: 5px;
  border-radius: 8px;
  width: fit-content;
  margin-bottom: 8px;
}

.quantity-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: white;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #DB5378;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.quantity-btn:hover:not(:disabled) {
  background: #DB5378;
  color: white;
}

.quantity-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.quantity-input {
  width: 60px;
  height: 32px;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  text-align: center;
  font-size: 1rem;
  color: #333;
  background: white;
  appearance: textfield;
  -moz-appearance: textfield;
}

.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.stock-info {
  font-size: 0.85rem;
  color: #666;
  display: flex;
  align-items: center;
  gap: 6px;
}

.purchase-limits {
  margin-top: 12px;
}

.limit-info {
  font-size: 0.85rem;
  color: #666;
  margin: 4px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.limit-info i {
  color: #DB5378;
}

.add-to-cart-btn {
  width: 100%;
  padding: 12px;
  background: #DB5378;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
  margin-bottom: 8px;
}

.add-to-cart-btn:hover {
  background: #45a049;
}

.remove-from-cart-btn {
  width: 100%;
  padding: 12px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.remove-from-cart-btn:hover {
  background: #c82333;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductBox.vue